module.exports = __webpack_public_path__ + "static/media/Shopping_Basket_Flat_Icon_Vector.2998d010.svg";